import { useSnackbar } from 'notistack';
import { useMutation } from 'react-query';
import { useQueryClient } from '@tanstack/react-query';

import { axios } from 'lib';
import { qnaKey } from 'features/qna/api/queryKeys';
import { toPlaceInputs } from 'utils/jobAdLocations';

const update = ({ values, jobAdID }) => {
  console.log('update job ad', values, jobAdID);
  const jsonData = {
    headline: values.headline,
    role: values.role,
    experience_level: values.experienceLevel,
    description: values.description,
    max_rate: values.maxRate,
    reference_number: values.referenceNumber,
    start_date: values.startDate,
    end_date: values.endDate,
    application_method: values.applicationType,
    application_email: values.applicationEmail,
    application_url: values.applicationURL,
    last_day_to_respond: values.lastDayToRespond,
    questions_end_date: values.questionsEndDate,
    competence_areas: values?.competenceAreas,
    locations: values?.usesNuts ? values?.locations : [],
    places: toPlaceInputs(values?.places),
    additional_periods: values?.additionalPeriods,
    type: values.type,
    hours_per_week: values.hoursPerWeek,
    assigned_user_id: values.assigned_user_id,
    hide_buyer: values.hideBuyer ?? false,
  };

  return axios.put(`/api/job_ads/${jobAdID}`, JSON.stringify(jsonData));
};

export const useUpdate = (refetch) => {
  const { enqueueSnackbar } = useSnackbar();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: update,
    onSuccess: (_, { jobAdID }) => {
      enqueueSnackbar('Job advertisment was succesfully updated', {
        variant: 'success',
      });

      queryClient.invalidateQueries({ queryKey: qnaKey('job_ads', jobAdID) });
      if (refetch) refetch();
    },
    onError: (error) => {
      enqueueSnackbar(error?.response?.data?.error || error?.message || 'Some error occured', { variant: 'error' });
    },
  });
};
